<template>
    <Overlay :show="showLoading">
        <b-row>
            <b-col md="8" lg="8">
                <b-card>
                    <div class="blog-content" v-html="introduction.content"></div>
                </b-card>
                <div class="d-flex justify-content-between">
                    <b-button
                        v-if="activeSentRequestsCount > 0"
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        variant="primary"
                        class="mr-1 position-relative"
                        @click="$router.push({name: 'sent-requests'})"
                    >
                        {{ $t(viewSentRequestsTranslation) }}
                        <b-badge class="button-badge badge-pill">{{ activeSentRequestsCount }}</b-badge>
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        variant="primary"
                        class="mr-1"
                        v-if="$can('visit', 'product-overview')"
                        @click="$router.push({name: 'product-overview'})"
                    >
                        {{ $t('Component(Button):view-products') }}
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        variant="primary"
                        class="position-relative"
                        @click="$router.push({name: 'received-requests'})"
                    >
                        {{ $t('Component(Button):view-received-requests') }}
                        <b-badge variant="primary" class="button-badge badge-pill">{{ activeReceivedRequestsCount }}</b-badge>
                    </b-button>
                </div>
            </b-col>
            <b-col md="4" lg="4">
                <h6 class="section-label mb-75">
                    {{ $t('Component(RecentPosts):title') }}
                </h6>
<!--                <b-card-->
<!--                    v-for="n in news"-->
<!--                    no-body-->
<!--                >-->
<!--                    <b-link :to="{ name: 'pages-blog-detail', params: { id: n.id } }">-->
<!--                        <b-img-->
<!--                            :src="n.image"-->
<!--                            class="card-img-top"-->
<!--                        />-->
<!--                    </b-link>-->

<!--                    <b-card-body>-->
<!--                        <b-card-title>-->
<!--                            <b-link-->
<!--                                :to="{ name: 'pages-blog-detail', params: { id: n.id } }"-->
<!--                                class="blog-title-truncate text-body-heading"-->
<!--                            >-->
<!--                                {{ n.title }}-->
<!--                            </b-link>-->
<!--                        </b-card-title>-->
<!--                        <div class="pb-1">-->
<!--                            <b-link-->
<!--                                v-for="(tag,index) in n.categories"-->
<!--                                :key="index"-->
<!--                            >-->
<!--                                <b-badge-->
<!--                                    pill-->
<!--                                    class="mr-75"-->
<!--                                    :variant="tagsColor(tag)"-->
<!--                                >-->
<!--                                    {{ tag.title }}-->
<!--                                </b-badge>-->
<!--                            </b-link>-->
<!--                        </div>-->
<!--                        <b-card-text class="blog-content-truncate">-->
<!--                            {{ n.shortDescription }}-->
<!--                        </b-card-text>-->
<!--                        <hr>-->
<!--                        <div class="d-flex justify-content-between">-->
<!--                            <small class="text-muted">{{ renderDate(n.createdAt) }}</small>-->
<!--                            <b-link>-->
<!--                                Read more-->
<!--                            </b-link>-->
<!--                        </div>-->
<!--                    </b-card-body>-->
<!--                </b-card>-->

                <b-media
                    v-for="(n,index) in news"
                    :key="n.images"
                    no-body
                    :class="index? 'mt-2':''"
                >
                    <b-media-aside class="mr-2">
                        <b-link>
                            <b-img
                                :src="n.image"
                                :alt="n.image.slice(6)"
                                width="120"
                                rounded
                            />
                        </b-link>
                    </b-media-aside>
                    <b-media-body>
                        <h6 class="blog-recent-post-title">
                            <b-link
                                class="text-body-heading"
                            >
                                {{ n.title }}
                            </b-link>
                        </h6>
                        <span class="text-muted mb-0">
                            {{ renderDate(n.createdAt) }}
                        </span>
                    </b-media-body>
                </b-media>
            </b-col>
        </b-row>
    </Overlay>
</template>

<script>
import {
    BFormInput, BAvatar, BImg, BLink, BFormGroup, BInputGroup, BInputGroupAppend,
    BCard, BRow, BCol, BBadge, BCardText, BDropdown, BDropdownItem, BForm, BFormTextarea, BFormCheckbox, BButton,
    BCardTitle, BCardHeader, BCardBody, BCardFooter, BMedia, BMediaAside, BMediaBody
} from 'bootstrap-vue'
import Overlay from "@core/components/common/Overlay";
import dateRenderer from "@core/mixins/date-renderer";
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import {PagesApi} from "@core/api";
import {isSustainity} from "@/libs/application";

export default {
    mixins: [dateRenderer],
    components: {
        BMedia, BMediaAside, BMediaBody, BImg, Overlay,
        BCardFooter,
        BFormInput,
        BAvatar,
        BLink,
        BCard,
        BRow,
        BCol,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BBadge,
        BCardText,
        BDropdown,
        BForm,
        BDropdownItem,
        BFormTextarea,
        BFormCheckbox,
        BButton,
        ContentWithSidebar,
        BCardTitle, BCardHeader, BCardBody
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            showLoading: true,
            search_query: '',
            commentCheckmark: '',
            blogDetail: [],
            blogSidebar: {},
            socialShareIcons: [
                'GithubIcon',
                'GitlabIcon',
                'FacebookIcon',
                'TwitterIcon',
                'LinkedinIcon',
            ],
            news: [],
            categories: [],
            introduction: {
                content: ''
            }
        }
    },
    methods: {
        kFormatter,
        tagsColor(tag) {
            if (tag === 'Quote') return 'light-info'
            if (tag === 'Gaming') return 'light-danger'
            if (tag === 'Fashion') return 'light-primary'
            if (tag === 'Video') return 'light-warning'
            if (tag === 'Food') return 'light-success'
            return 'light-primary'
        },
        retrievePageContent(key, showLoading) {
            if (showLoading) {
                this.showLoading = true;
            }
            return PagesApi.getParsedSystemContent(key).then(r => {
                this.introduction = r.data;
                if (showLoading) {
                    this.showLoading = false;
                }
            });
        }
    },

    computed: {
        viewSentRequestsTranslation() {
            if (true === this.$store.getters.isFreeSubscriber) {
                return 'Component(Button):view-forwarded-requests';
            }
            return 'Component(Button):view-sent-requests';
        },
        profile() {
            return this.$store.getters.profile;
        },
        activeSentRequestsCount() {
            return this.$store.getters.activeSentRequestsCount;
        },
        activeReceivedRequestsCount() {
            return this.$store.getters.activeReceivedRequestsCount;
        },
        systemContentKey() {
            const isSubscriptionActive = this.$store.getters.subscription.isActive;
            if (isSustainity()) {
                return isSubscriptionActive ? 'sustainity-subscriber-introduction' : 'sustainity-supplier-introduction';
            }
            return isSubscriptionActive ? 'subscriber-introduction' : 'supplier-introduction';
        }
    },

    watch: {
        systemContentKey(newKey) {
            this.retrievePageContent(newKey, true);
        }
    },

    created() {
        Promise.all([
            PagesApi.getFeaturedNews().then(r => {
                this.news = r.data.news;
                this.categories = r.data.categories;
            }),
            this.retrievePageContent(this.systemContentKey)
        ]).then(() => this.showLoading = false);
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
